<template>
  <section
    id="intro"
    class="text-center mb-12"
  >
    <h1 class="display-2 lushary--text font-weight-light mb-8">
      Услуги
    </h1>

    <v-responsive
      class="mx-auto subtitle-1 grey--text"
      max-width="550"
    >
      Для удобства все съемки разделены на категории. Если Вы подобрали какую-то услугу — смело связывайтесь со мной и переходите по ссылкам, указанным ниже.
    </v-responsive>
  </section>
</template>

<script>
  export default {
    name: 'PortfolioHeadline',
  }
</script>
